<template>
	<div class="gallary_screen">
		<div class="carousel_box">
			<carousel v-if="screenWidth > 520"
				:per-page="1"
				:mouse-drag="true"
				:loop="true"
				:navigationEnabled="true"
				:navigationNextLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 40C1 31.2193 8.7463 23.6256 20 20C8.7463 16.3744 1 8.7807 1 -2.22278e-06' stroke='#A39171' style='stroke:#A39171;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
				:navigationPrevLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M20 40C20 31.2193 12.2537 23.6256 0.999999 20C12.2537 16.3744 20 8.7807 20 -2.22278e-06' stroke='#A39171' style='stroke:#A39171;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
			>
				<slide :key="idx" v-for="(itm, idx) in carousel_items">
					<div class="carousel_item_box">
						<img class="carousel_item_box_img" :src="itm.img" alt="">
						<div  class="carousel_item_box_description">
							<div class="carousel_item_box_description_title">{{ itm.title }}</div>
							<div class="carousel_item_box_description_text">
								{{ itm.description }}
							</div>
						</div>
					</div>
				</slide>
			</carousel>
			<carousel v-else
				:per-page="1"
				:mouse-drag="true"
				:navigationEnabled="false"
				:navigationNextLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 40C1 31.2193 8.7463 23.6256 20 20C8.7463 16.3744 1 8.7807 1 -2.22278e-06' stroke='#A39171' style='stroke:#A39171;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
				:navigationPrevLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M20 40C20 31.2193 12.2537 23.6256 0.999999 20C12.2537 16.3744 20 8.7807 20 -2.22278e-06' stroke='#A39171' style='stroke:#A39171;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
			>
				<slide :key="idx" v-for="(itm, idx) in carousel_items">
					<div class="carousel_item_box">
						<img class="carousel_item_box_img" :src="itm.img" alt="">
						<div  class="carousel_item_box_description">
							<div class="carousel_item_box_description_title">{{ itm.title }}</div>
							<div class="carousel_item_box_description_text">
								{{ itm.description }}
							</div>
						</div>
					</div>
				</slide>
			</carousel>
		</div>
		<br>
		<br>
	</div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';

export default {
	name: "GallaryComponent",
	components: {
		Carousel,
		Slide,
	},
	data() {
		return {
			screenScrolled: 0,
			screenWidth: 0,
			screenHeight: 0,

			carousel_items: [
				{
					id: 1,
					img: require('../assets/img/site/1.jpg'),
					title: 'DOLPHIN PLANET HOTEL & SPA',
					description: `
						Территория истинного счастья в которой есть все необходимое для отдыха и развлечений.
						Большое количество дополнительных услуг и специальных предложений превращают каждое
						посещение комплекса в незабываемое приключениfе.
					`,
				},
				{
					id: 2,
					img: require('../assets/img/site/20.jpg'),
					title: 'ОТДЫХ ДЛЯ ВСЕЙ СЕМЬИ',
					description: `
						В Dolphin Planet вы сможете восполнить энергию, зарядиться и получить новые яркие впечатления.
						Любовь к себе начинается с качественного отдыха. И это именно то место, где созданы все
						необходимые условия для этого.
					`,
				},
				{
					id: 3,
					img: require('../assets/img/site/6.jpg'),
					title: 'АКЦИИ И СПЕЦПРЕДЛОЖЕНИЯ',
					description: `
						Отличная возможность дополнить свой отдых бонусами на проживание или услуги.
						Регулярно обновляем систему спецпредложений, чтобы каждый раз приятно удивлять вас!
					`,
				},
			],
		}
	},
	mounted() {
		window.addEventListener('resize', this.handleResize)
		window.addEventListener('scroll', this.handleScroll)
		this.handleResize()
		this.handleScroll()
	},
	computed: {
		// screenScrolled() {
		// 	return window.scrollY
		// }
	},
	methods: {
		handleScroll() {
			this.screenScrolled = window.scrollY;
		},
		handleResize() {
			this.screenWidth = window.innerWidth;
			this.screenHeight = window.innerHeight;
		}
	},
}
</script>

<style>


.VueCarousel-dot, .VueCarousel-dot:active {
	background-color: transparent !important;
	border: 1px solid #A39171 !important;
	padding: 0 !important;
	margin: 0.5em;
}
.VueCarousel-dot.VueCarousel-dot--active {
	background-color: #A39171 !important;
}
.carousel_box {
	width: 80%;
	/*padding: 0 10%;*/
	margin: 0 auto;
	/*display: flex;*/
	/*flex-direction: column;*/
	/*flex-wrap: nowrap;*/
	/*justify-content: center;*/
	/*align-items: center;*/
	/*align-content: center;*/
}
.gallary_screen {
	/*height: 500px;*/
	padding: 2em;
	background: #F7F3EDFF;
	width: 100%;
	text-align: center;
	position: relative;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: center;
}


.carousel_item_box {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: center;
	align-items: flex-start;
	justify-content: center;
}

.carousel_item_box_img {
	width: 60%;
	font-weight: 400;
	object-fit: cover;
	height: 100%;
	border-radius: 10px 10px 10px 10px;
}
.carousel_item_box_description {
	color: #333333;
	padding-left: 1.5em;
	width: 40%;
	text-align: left;
}

.carousel_item_box_description_title,
.carousel_item_box_description_text {
	font-weight: 400;
}

.carousel_item_box_description_title {
	font-size: 2em;
}

.carousel_item_box_description_text {
	color: #333333;
}

.VueCarousel-navigation-next {
	right: -15px !important;
}

.VueCarousel-navigation-prev {
	left: -15px !important;
}

@media (max-width: 575px) {
	.gallary_screen {
		height: 100vh;
		overflow: hidden;
		padding: 0em;
		background: #F7F3EDFF;
		width: 100%;
		text-align: center;
		position: relative;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		justify-content: center;
	}
	.carousel_box {
		width: 100%;
		margin: 0 auto;
		padding: 0;
	}

	.carousel_item_box {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		align-items: flex-start;
		justify-content: center;
		width: 100%;
		padding: 1em;
	}
	.carousel_item_box_img {
		width: 100%;
		font-weight: 400;
		object-fit: cover;
		height: 30vh;
		border-radius: 10px 10px 0px 0px;
	}
	.carousel_item_box_description {
		color: #333333;
		padding: 1em;
		padding-bottom: 3em;
		font-size: 12px;
		width: 100%;
		text-align: left;
		background-color: #F7F3ED;
		border-radius: 0px 0px 10px 10px;

	}
	.carousel_item_box_description_title {
		font-size: 2em;
	}
	.carousel_item_box_description_text {
		font-size: 1em;
	}
}
</style>